import React from "react";

const Stars: React.FC = () => {
  return (
    <svg
      width={263}
      height={220}
      viewBox="0 0 263 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M168.393 33.8492L208.71 22.883L224.559 81.1505L282.952 65.2676L293.899 105.516L251.676 117.001L301.874 152.99L277.51 186.884L220.57 146.062L192.147 210.085L153.975 193.195L179.028 136.761L136.797 148.248L125.849 108L184.242 92.1167L168.393 33.8492Z"
        fill="#F7A3D5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.1084 -11.679L94.8473 -27.3307L117.468 28.6568L173.576 5.98747L189.201 44.661L148.63 61.053L202.728 90.8604L182.538 127.396L121.175 93.585L100.513 160.517L60.613 148.254L78.8252 89.2563L38.246 105.652L22.6207 66.978L78.729 44.3085L56.1084 -11.679Z"
        fill="#92D400"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M183.205 29.8204L168.393 33.8492L173.103 51.165L189.201 44.661L183.205 29.8204ZM180.582 78.6582L202.728 90.8605L182.538 127.396L140.235 104.087L184.242 92.1168L180.582 78.6582Z"
        fill="#C3009E"
      />
    </svg>
  );
};

export default Stars;
